import { createClient, IdPathParameters, SearchOperation, searchRequestFactory } from '@infuse/api/common';

const client = createClient('/rest/operator-api/charging-stations');

export enum UpdateFirmwareStatus {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_CANCELED = 'ACCEPTED_CANCELED',
  REJECTED = 'REJECTED',
  INVALID_CERTIFICATE = 'INVALID_CERTIFICATE',
  REVOKED_CERTIFICATE = 'REVOKED_CERTIFICATE'
}

export enum FirmwareStatus {
  DOWNLOADED = 'DOWNLOADED',
  DOWNLOAD_FAILED = 'DOWNLOAD_FAILED',
  DOWNLOADING = 'DOWNLOADING',
  IDLE = 'IDLE',
  INSTALLATION_FAILED = 'INSTALLATION_FAILED',
  INSTALLING = 'INSTALLING',
  INSTALLED = 'INSTALLED',
  DOWNLOAD_SCHEDULED = 'DOWNLOAD_SCHEDULED',
  DOWNLOAD_PAUSED = 'DOWNLOAD_PAUSED',
  INSTALL_REBOOTING = 'INSTALL_REBOOTING',
  INSTALL_SCHEDULED = 'INSTALL_SCHEDULED',
  INSTALL_VERIFICATION_FAILED = 'INSTALL_VERIFICATION_FAILED',
  INVALID_SIGNATURE = 'INVALID_SIGNATURE',
  SIGNATURE_VERIFIED = 'SIGNATURE_VERIFIED'
}

export interface FirmwareUpdate {
  id: string;
  fileName: string;
  retrieveAt: Date;
  installAt?: Date;
  secure: boolean;
  createdAt: Date;
  responseReceivedAt?: Date;
  responseStatus?: UpdateFirmwareStatus;
  errorCode?: string; // OCPP 2.x only
  firmwareStatus?: FirmwareStatus;
  firmwareStatusModifiedAt?: Date;
}

export const chargingStationFirmwareUpdatesPermissions = {
  GET: 'cpms.get-charging-station-firmware-update-statuses'
};

export const getChargingStationFirmwareUpdates: SearchOperation<
  FirmwareUpdate,
  IdPathParameters<string>
> = searchRequestFactory<FirmwareUpdate, IdPathParameters<string>>(client, {
  pattern: '/{id}/firmware-updates',
  permissionId: chargingStationFirmwareUpdatesPermissions.GET
});
